export default __webpack_public_path__ + "static/media/person_placeholder.7390b75d.jpeg";